module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', [_c('navbar', {
    attrs: {
      "returnPath": "loginPage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "background"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "account-page"
  }, [_c('div', {
    staticClass: "center-screen"
  }, [_c('v-ons-row', [_c('p', {
    staticClass: "login-header"
  }, [_vm._v("Création de compte")])]), _vm._v(" "), _c('v-ons-row', [_c('p', {
    staticClass: "login-info"
  }, [_vm._v("Votre pseudonyme sera généré aléatoirement pour garantir votre anonymat. Veuillez simplement entrer un mot de passe !")])]), _vm._v(" "), _c('v-ons-row', {
    staticClass: "login-form"
  }, [_c('v-ons-input', {
    attrs: {
      "placeholder": "Choisis un mot de passe",
      "float": "",
      "type": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('v-ons-row', [_c('v-ons-col', [_c('v-ons-button', {
    staticClass: "btn",
    attrs: {
      "modifier": "large",
      "disabled": _vm.loading || !_vm.password
    },
    on: {
      "click": function($event) {
        return _vm.validatePassword()
      }
    }
  }, [_vm._v("Créer le compte")])], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5ecdb9a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login-form/AccountCreationPage.vue
// module id = 717
// module chunks = 1